import { Flex, Image } from '@chakra-ui/react'
import * as T from '../../../components/Table'
import { ModalImagensProduct } from './ModalImagensProduct'

export function ItemHistoryRegisterProduct({ product }) {
  return (
    <T.Tr>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        <Flex flexDir="column" alignItems="center">
          <Image boxSize={10} src={product.imagens[0]} alt="Product" mx="auto" />
          <ModalImagensProduct images={product.imagens} />
        </Flex>
      </T.Td>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        {product.codigo_produto}
      </T.Td>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        {product.descricao_produto}
      </T.Td>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        {product.codigo_usuario} - Falta colocar usuário
      </T.Td>
      <T.Td py={1}>{product.dt_cad} - Falta colocar Data</T.Td>
    </T.Tr>
  )
}
